import { RootState } from '../../reducers'

export const documentAlertsDisplayableSamAlertsSelector = (state: RootState) =>
  state.ui.documentAlerts.displayableSamAlerts

export const documentAlertsAcknowledgedSamAlertsSelector = (state: RootState) =>
  state.ui.documentAlerts.acknowledgedSamAlerts
